import Cookies from 'js-cookie';
import moment from 'moment';
import { t } from 'i18next';

export default function getGeolocation() {
  // override the write function to remove any encoding. David wants the RAW Json.
  const cookies = Cookies.withConverter({
    write: function(value) {
      const b64EncodedValue = btoa(value.toString());
      return b64EncodedValue;
    },
  });

  const cookieKey = 'geolocation';

  if (navigator.geolocation) {
    let options = { enableHighAccuracy: true, timeout: 10000 /* 10seconds */ };
    navigator.geolocation.getCurrentPosition(
      position => setPosition(position),
      () => doNotSetPosition(),
      options
    );
  } else {
    throw new Error(t('Geolocation is not supported by this browser.'));
  }

  // if the user has set the position cookie and then blocked the browser from getting position (an edge case), we need to remove the location cookie.
  function doNotSetPosition() {
    Cookies.remove(cookieKey);
  }

  function setPosition(position: GeolocationPosition) {
    if (position == null || position.coords == null) {
      return;
    }

    const { coords, timestamp } = position;

    let time = moment(timestamp).format();

    // APE-3632:  Safari bug, it returns 1986 for the year in the getPosition timestamp.
    // Detecting safari and setting the timestamp manually when safari.
    const isSafari = (window as any).safari !== undefined;
    if (isSafari) {
      time = moment().format();
    }

    cookies.set(cookieKey, JSON.stringify({
      lat: coords.latitude,
      long: coords.longitude,
      accuracy: coords.accuracy,
      timestamp: time,
    }));
  }
}
